/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import InvestorAwareness from "./investor-awareness";

export default InvestorAwareness;
